import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { alpha, styled } from '@mui/material/styles';
import { grey , blue} from '@mui/material/colors';
import { Grid, Switch, Select, FormControl, InputLabel, MenuItem} from '@mui/material';


import LoadingButton from '@mui/lab/LoadingButton';

import CmsContext from '../../../../../../store/cms-context';

import SyncIcon from '@mui/icons-material/Sync';

import cloneDeep from 'lodash/cloneDeep';

const CustomSwitch = styled(Switch)(({ theme }) => ({

  '& .MuiSwitch-switchBase': {
    '&.Mui-checked': {
      '& .MuiSwitch-thumb': {
        color:blue[800]
      }
    },
    '&:hover': {
      backgroundColor: alpha(blue[600], theme.palette.action.hoverOpacity),
    }
  },
  '& .MuiSwitch-thumb': {
    color:grey[200]
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: blue[300],
        opacity: 1,
        border: 0,
  },
  
}));


function TaskDialog(props) {

  console.log("task dialog state was: ", props.task_dialog_state)

  const cmsContext = React.useContext(CmsContext);
  

  
  function handle_close(){

    const temp_state = {...props.task_dialog_state}

    temp_state.is_dialog_open = false

    props.set_task_dialog_state(temp_state)

  }

  return (
    <div>
      <Dialog
        open={props.task_dialog_state.is_dialog_open}
        onClose={handle_close}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
         {props.task_dialog_state.type} Sync Task
        </DialogTitle>

        <DialogContent dividers>


          <Grid
            container
            spacing={3}
            alignItems="center"
            >

            <Grid item xs={12}>

              <div style={{textAlign:'center', marginTop:16}}>

              <img src="/static/images/storage-stacks.png" alt='g_ads' style={{width:80, height:80}}></img>
              <SyncIcon color="primary" style={{marginLeft:20, marginRight:20, marginBottom:16}}></SyncIcon>
              <img src="/static/images/shopify_speed.png" alt='g_search' style={{width:80, height:80}}></img>

              </div>

            </Grid>

           {props.task_dialog_state && props.task_dialog_state.mintsoft_clients ? <Grid item xs={12}>

              <FormControl sx={{ width:'100%', marginTop:2}}>

              <InputLabel id="demo-simple-select-autowidth-label">Mintsoft Client</InputLabel>

              <Select
              labelId="demo-simple-select-autowidth-label"
              id="demo-simple-select-autowidth"
              fullWidth
              value={Object.keys(props.task_dialog_state.mintsoft_client).length > 0 ? props.task_dialog_state.mintsoft_client : {}}
              onChange={(event)=> {

                const temp_dialog_state = {...props.task_dialog_state};
                temp_dialog_state.mintsoft_client = event.target.value;
                const filtered_mintsoft_warehouses = []
                console.log("temp dialog state mintsoft warehouses: ", temp_dialog_state.mintsoft_warehouses)
                temp_dialog_state.mintsoft_warehouses.forEach((warehouse) => {

                  console.log('warehouse client name: ', warehouse.client_name)
                  console.log('temp dialog state mintsoft client short name: ', temp_dialog_state.mintsoft_client.short_name)
                  if(warehouse.client_name === temp_dialog_state.mintsoft_client.short_name) {
                    filtered_mintsoft_warehouses.push(warehouse)
                  }
                })
                temp_dialog_state.filtered_mintsoft_warehouses = filtered_mintsoft_warehouses
                props.set_task_dialog_state(temp_dialog_state)

              }}
              label="Mintsoft Client"
              >

              {props.task_dialog_state.mintsoft_clients.map((item, index) => (
                <MenuItem key={index} value={item}>{item.name}</MenuItem>
              ))}

              </Select>

              </FormControl>

              </Grid> : null }


              {props.task_dialog_state && props.task_dialog_state.filtered_mintsoft_warehouses.length > 0 ? <Grid item xs={12}>

              <FormControl sx={{ width:'100%', marginTop:2}}>

              <InputLabel id="demo-simple-select-autowidth-label">Mintsoft Warehouse</InputLabel>

              <Select
              labelId="demo-simple-select-autowidth-label"
              id="demo-simple-select-autowidth"
              fullWidth
              value={Object.keys(props.task_dialog_state.mintsoft_warehouse).length > 0 ? props.task_dialog_state.mintsoft_warehouse : ''}
              onChange={(event)=> {

                console.log('event target value: ', event.target.value);
                const temp_dialog_state = {...props.task_dialog_state};
                temp_dialog_state.mintsoft_warehouse = event.target.value;
                props.set_task_dialog_state(temp_dialog_state)

              }}
              label="Mintsoft Warehouse"
              >

              {props.task_dialog_state.filtered_mintsoft_warehouses.map((item, index) => (
                <MenuItem key={index} value={item}>{item.name}</MenuItem>
              ))}

              </Select>

              </FormControl>

              </Grid> : null }

            {props.task_dialog_state.all_stores != null ? <Grid item xs={12}>

            <FormControl sx={{ width:'100%', marginTop:2}}>

            <InputLabel id="demo-simple-select-autowidth-label">Shopify Account</InputLabel>

            <Select
              labelId="demo-simple-select-autowidth-label"
              id="demo-simple-select-autowidth"
              fullWidth
              value={Object.keys(props.task_dialog_state.shopify_store).length > 0 ? props.task_dialog_state.shopify_store.store : ''}
              onChange={(event) => {

                console.log('event target value: ', event.target.value);
                const temp_dialog_state = {...props.task_dialog_state};
                const index = temp_dialog_state.all_stores.findIndex(store => store.store === event.target.value);
                console.log('found_index', index);
                temp_dialog_state.shopify_store = cloneDeep(temp_dialog_state.all_stores[index]);

                const filtered_shopify_inventory_locations = []

                temp_dialog_state.shopify_inventory_locations.forEach((location) => {

                  if(location.store === temp_dialog_state.shopify_store.store){

                    filtered_shopify_inventory_locations.push(location)

                  }

                })
                
                temp_dialog_state.filtered_shopify_inventory_locations = filtered_shopify_inventory_locations

                props.set_task_dialog_state(temp_dialog_state)

              }}
              label="Shopify Account"
            >

              {props.task_dialog_state.all_stores.map((item, index)=> (
                <MenuItem key={index} value={item.store}>{item.name}</MenuItem>
              ))}
              
            </Select>

            </FormControl>

            </Grid> : null}

            {props.task_dialog_state && props.task_dialog_state.filtered_shopify_inventory_locations.length > 0 ? <Grid item xs={12}>

            <FormControl sx={{ width:'100%', marginTop:2}}>

            <InputLabel id="demo-simple-select-autowidth-label">Shopify Inventory Location</InputLabel>

            <Select
              labelId="demo-simple-select-autowidth-label"
              id="demo-simple-select-autowidth"
              fullWidth
              value={Object.keys(props.task_dialog_state.shopify_inventory_location).length > 0 ? props.task_dialog_state.shopify_inventory_location : {}}
              onChange={(event) => {

                console.log('event target value: ', event.target.value);
                const temp_dialog_state = {...props.task_dialog_state};
                temp_dialog_state.shopify_inventory_location = event.target.value;
                props.set_task_dialog_state(temp_dialog_state)

              }}
              label="Shopify Inventory Location"
            >

              {props.task_dialog_state.filtered_shopify_inventory_locations.map((item, index)=> (
                <MenuItem key={index} value={item}>{item.name}</MenuItem>
              ))}
              
            </Select>

            </FormControl>

            </Grid> : null}

            </Grid>

        </DialogContent>
        <DialogActions>
        <Button onClick={handle_close} variant='outlined'>{"Cancel"}</Button>
        <LoadingButton variant='outlined' loading={props.task_dialog_state.isLoading} disabled={false} onClick={() => {props.post_sync_task()}}>{props.task_dialog_state.action_type}</LoadingButton>
        </DialogActions>
      </Dialog>
    </div>
  );




}



export default TaskDialog;